import { useSelector } from 'react-redux';

const useLoading = () => {
  const { loading } = useSelector((state) => state.loadingSlice);

  return {
    loading,
  };
};

export default useLoading;
